import { gql } from '@apollo/client'

export const InviteUserMutation = gql`
    mutation inviteUser($inviteUserInput: InviteUserInput!) {
        inviteUser(input: $inviteUserInput) {
            id
            email
            status
            profileInfo {
                firstName
                lastName
            }
            isOnboarder
        }
    }
`

export const SetUserStatusMutation = gql`
    mutation setUserStatus($setUserStatusInput: SetUserStatusInput!) {
        setUserStatus(input: $setUserStatusInput)
    }
`

export const UpdateUserMutation = gql`
    mutation updateUser($updateUserInput: UpdateUserInput!) {
        updateUser(input: $updateUserInput) {
            id
            email
            role
            status
            isBestPracticeGroupEnabled
            isDesignatedAccountAdminUser
            profileInfo {
                firstName
                lastName
                professionalDiscipline
                professionalRole
            }
            isOnboarder
        }
    }
`

export const ToggleDontShowAgainMutation = gql`
    mutation {
        toggleShowGettingStartedAgain {
            id
            firmId
            showGettingStartedAgain
        }
    }
`
export const AcceptTermsAndConditionsMutation = gql`
    mutation acceptTermsAndConditions {
        acceptTermsAndConditions
    }
`

export const SetUserLastActiveDateMutation = gql`
    mutation setUserLastActiveDate {
        setUserLastActiveDate
    }
`

export const AddUserTokenToBlacklistMutation = gql`
    mutation addUserTokenToBlacklist {
        addUserTokenToBlacklist
    }
`
